<!-- Only one ng-content is allowed -->
<ng-template #singleContent><ng-content></ng-content></ng-template>
@if (!pending) {
@if (file) {
<!-- Note, disabled does not impact visual -->
<label class="button {{btnClass}}">
	<ng-container *ngTemplateOutlet="singleContent"></ng-container>
	<input [disabled]="disabled" (change)="PerformAction($event)" type="file" class="form-control-file">
</label>
} @else {
<button [disabled]="disabled" (click)="PerformAction()" class="button {{btnClass}}" [type]="submit ? 'submit' : 'button'">
	<ng-container *ngTemplateOutlet="singleContent"></ng-container>
</button>
}
}
@if (pending) {
<button class="button {{btnClass}}" disabled>{{processing}}</button>
}
@if (problem) {
<div class="problem message-bad">{{problem}}</div>
}
@if (success && (complete || actionResult)) {
<div class="success message-good">{{complete || actionResult}}</div>
}